import { MediaContextQueryDocument } from "@pathwright/graphql-client/src/generated"

export default MediaContextQueryDocument
